var TECL_Products = {

	addToCartSnippet: '<div class="adding-to-cart"> \
		<div class="action-badge"> \
			<div class="glyphicon glyphicon glyphicon-ok"></div> \
		</div> \
	</div>'
	,
	Initialise: function() {
		$('.add-to-cart').on('click', function(e) {
			e.preventDefault();
			if ( !$(this).hasClass('added-to-cart') ) {
				TECL_Products.AddToCart(this);
			} else {
				TECL_Products.RemoveFromCart(this);
			}
		});
	}
	,
	AddToCart: function(element) {
		$(element).parent().parent().append(TECL_Products.addToCartSnippet);
		$(element).addClass('added-to-cart').text('Remove');
		$('#cartProductCount').text(parseInt($('#cartProductCount').text()) + 1);
	}
	,
	RemoveFromCart: function(element) {
		$(element).parent().parent().children('.adding-to-cart').remove();
		$(element).removeClass('added-to-cart').text('Add to Cart');
		$('#cartProductCount').text(parseInt($('#cartProductCount').text()) - 1);
	}
};
